// noinspection JSUnusedGlobalSymbols

import { collection, type Reference } from "@doitintl/models-types";

import { type OrganizationsModel } from "./Organizations";
import { type RoleModel } from "./Role";

export type SsoUserGroupModel = {
  groupId: string;
  roleAtDoit: Reference<RoleModel>;
  org: Reference<OrganizationsModel>;
};

@collection("ssoGroups")
export class SsoGroupModel {
  customerId!: string;

  providerAttributeKey!: string;

  userGroups!: SsoUserGroupModel[];
}

type SsoUserGroupDTO = {
  groupId: string;
  roleAtDoit: string;
  org: string;
};

export type SsoGroupDTO = {
  customerId: string;
  providerAttributeKey: string;
  userGroups: SsoUserGroupDTO[];
};
